/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Process_ButtonInputs */

const en_register_onboarding_personal_info_process_button = /** @type {(inputs: Register_Onboarding_Personal_Info_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process`)
};

const de_register_onboarding_personal_info_process_button = /** @type {(inputs: Register_Onboarding_Personal_Info_Process_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeiten`)
};

/**
* | output |
* | --- |
* | "Process" |
*
* @param {Register_Onboarding_Personal_Info_Process_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_process_button = /** @type {((inputs?: Register_Onboarding_Personal_Info_Process_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Process_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_process_button(inputs)
	return en_register_onboarding_personal_info_process_button(inputs)
});